{
  "about": {
    "title": "О Spring Boot Admin",
    "label": "О проекте"
  }
}
